export default __webpack_public_path__ + "static/ic_cer_9001-728ef373ab4fe53df0e2339f96c28901.png";